<script lang="ts">
import { defineComponent } from 'vue';
import { AisRefinementList } from 'vue-instantsearch/vue3/es';
// Directives
import dropdown from '@vue-directives/dropdown';

export default defineComponent({
  components: {
    AisRefinementList,
  },
  directives: {
    dropdown,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    attribute: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
});
</script>
<template>
  <div v-dropdown class="dropdown group relative">
    <button
      aria-expanded="false"
      class="dropdown-trigger relative flex w-full cursor-pointer items-center justify-between gap-4 border-b border-solid border-ick-neutral-400 pb-3 font-barlow-condensed text-2xl/[1.75] font-extrabold transition-colors duration-300 group-[.open]:text-purple-400"
      type="button"
    >
      {{ label }}
      <svg
        width="28"
        height="28"
        class="text-white transition-[rotate,color] duration-300 ease-out-quint group-[.open]:rotate-180 group-[.open]:text-ick-lime-500 motion-reduce:transition-[color]"
        aria-hidden="true"
      >
        <use xlink:href="#chevron-circle-dark" />
      </svg>
    </button>

    <ais-refinement-list
      :attribute="attribute"
      :limit="100"
      :sort-by="['name:asc']"
      :class-names="{
        'ais-RefinementList':
          'absolute top-full left-0 z-1 hidden w-max max-w-176 min-w-full rounded-b-xl shadow-md bg-white group-[.open]:block',
        'ais-RefinementList-count': 'hidden',
        'ais-RefinementList-list': 'py-3 px-6 font-base font-barlow-condensed font-extrabold',
        'ais-RefinementList-item--selected': 'bg-ick-neutral-50',
        'ais-RefinementList-label': 'block py-2',
        'ais-RefinementList-labelText': 'px-3',
        'ais-RefinementList-checkbox': 'accent-ick-neutral-400',
      }"
    />
  </div>
</template>
